import React from "react"

interface HamburgerIconProps {
  className?: string
  size?: number
}

export const HamburgerIcon: React.FC<HamburgerIconProps> = ({ className = "", size = 24 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 6h16M4 12h16M4 18h16"
    />
  </svg>
)
